// AI-CONTEXT: See docs/features/dashboard-participation-ladder-growth-card.md
import { useMemo } from 'react'
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined'

/**
 * Single-persona filter chip. Option values are `persona.ID`. Takes the persona
 * list as a prop (the card already loads it) to avoid a duplicate listener.
 *
 * @param {object} props
 * @param {Array<{ID: string, Name?: string}>} props.personas - all personas
 * @param {string} props.selectedPersonaId - currently selected persona ID ('' = all)
 * @param {(id: string) => void} props.onChange - called with the new persona ID
 */
const DashboardPersonaSelectFilter = ({ personas = [], selectedPersonaId, onChange }) => {
    const list = useMemo(() => {
        const arr = Array.isArray(personas) ? [...personas] : []
        arr.sort((a, b) => String(a?.Name || '').localeCompare(String(b?.Name || '')))
        return arr
    }, [personas])

    if (list.length === 0) return null

    return (
        <label className="dashboard-filter-chip">
            <PersonOutlineOutlinedIcon fontSize="small" className="dashboard-filter-chip-icon" />
            <span className="dashboard-filter-chip-label">Medewerker:</span>
            <select
                className="dashboard-filter-chip-select"
                value={selectedPersonaId || ''}
                onChange={(e) => onChange(e.target.value)}
            >
                <option value="">Alle</option>
                {list.map((persona) => (
                    <option key={persona.ID} value={persona.ID}>
                        {persona.Name || '—'}
                    </option>
                ))}
            </select>
        </label>
    )
}

export default DashboardPersonaSelectFilter
